<app-navbar></app-navbar>
<div (click)="toggleTooltip($event, null)" style="margin-bottom: 1em" *ngIf="!isLoading">
    <main role="main" class="container">

        <div class="col-md-7">
            <div class="course-links">
                <a href="{{ACTIVITY_DETAILS_TEMPLATE.replace('{cecityActivityId}', cecityActivityId)}}"><<  Back to course details</a>
                <a href="{{LEARNING_HOME}}">Learning Home</a>
            </div>
            <h1 class="c-hdg c-hdg_5">{{headline}}</h1>
            <br />
            <div style="font-size: 12px;">

                <app-error-modal *ngIf="showErrorModal" (closeModal)="closeErrorDialog()"></app-error-modal>
             <div *ngIf="qMedActivityNotAvailable">
                <div class="warning-box">
                    <em class="material-icons">warning</em>
                    <div style="padding-top: 10px;">This version of the program is no longer available. Please purchase the newer version instead.</div>
                </div>    
                <button class="btn_full" type="submit" (click)="purchaseNewProgramVersion()">Purchase New Program Version</button>              
              </div>  
             <div *ngIf="!qMedActivityNotAvailable">
                <div *ngIf="affiliationSuccess">
                    <div class="success-box">
                        <em class="material-icons">check_circle</em>
                        <div>
                            <p>You have been affiliated with CAP # {{labInfo.capNumber}} {{orgFullName}}, {{orgFullAddress}}, {{labInfo.city}}, {{labInfo.state}} {{labInfo.postalCode}}.</p>
                        </div>
                    </div>
                    <br />
                    <button class="btn_full" type="submit" (click)="continueToActivity()">Complete Activity Registration</button>
                </div>

            <div *ngIf= "activity.processFlowType !== '1:M/PURCHASE'">    
                <div *ngIf="(!kitsAvailable || (labsHavingKits.length == 0 && hasLabAffiliation && kitsFulfilled && !affiliationSuccess)) 
                             && !invalidCap && !showConfirmation && !allKitsUsed">
                    <div class="warning-box">
                        <em class="material-icons">warning</em>
                        <div>
                            Your laboratory/organization is not enrolled in this program. You may:
                            <ul>
                                <li>Enter a different laboratory/organization CAP #</li>
                                <li>Contact your administrator</li>
                                <li><a href={{CAP_CONTACT_URL}} target="_blank" rel="noopener noreferrer">Contact the CAP</a></li>
                                <li *ngIf="activity.processFlowType !== '1:M' && activity.processFlowType !== 'KIT_CAP/PURCHASE' && hasLabAffiliation"><a href={{E_STORE_URL}}>Purchase this activity</a></li>
                                <li *ngIf="activity.processFlowType == 'KIT_CAP/PURCHASE'"><a href={{E_STORE_URL}}>Purchase this activity</a></li>
                            </ul>
                        </div>
                    </div>
                    <br />
                </div>

                <div *ngIf="allKitsUsed && !invalidCap && !showConfirmation && !affiliationSuccess && kitsFulfilled">
                    <div class="warning-box">
                        <em class="material-icons">warning</em>
                        <div>
                            There are no more kits(seats) available for this laboratory/organization.
                            <br>
                            You may:
                            <ul>
                                <li>Enter a different laboratory/organization CAP #</li>
                                <li>Contact your administrator</li>
                                <li><a href={{CAP_CONTACT_URL}} target="_blank" rel="noopener noreferrer">Contact the CAP</a></li>
                                <li *ngIf="activity.processFlowType !== '1:M'"><a href={{E_STORE_URL}}>Purchase this activity</a></li>
                            </ul>
                        </div>
                    </div>
                    <br />
                </div>

                <div *ngIf="!hasLabAffiliation && kitsAvailable && !invalidCap && !showConfirmation && !allKitsUsed">
                    <div class="warning-box">
                        <em class="material-icons">warning</em>
                        <div>
                            You are currently not affiliated with a laboratory/organization. You may:
                            <ul>
                                <li>Enter laboratory/organization CAP # to create an affiliation</li>
                                <li>Contact your administrator</li>
                                <li><a href={{CAP_CONTACT_URL}} target="_blank" rel="noopener noreferrer">Contact the CAP</a></li>
                                <li *ngIf="activity.processFlowType !== '1:M'"><a href={{E_STORE_URL}}>Purchase this activity</a></li>
                            </ul>
                        </div>
                    </div>
                    <br />
                </div>

                <div *ngIf="!kitsFulfilled && !affiliationSuccess">
                    <div class="warning-box">
                        <em class="material-icons">warning</em>
                        <div>
                            <p>Activity is not available</p>
                            <p>You may <a href="{{CAP_CONTACT_URL}}" target="_blank" rel="noopener noreferrer">contact the CAP</a> for assistance.</p>
                        </div>
                    </div>
                    <br />
                </div>
            </div> 
         
            <div *ngIf= "activity.processFlowType == '1:M/PURCHASE'">   
                <div *ngIf=" (!kitsAvailable || (labsHavingKits.length == 0 && hasLabAffiliation && !affiliationSuccess)) && !invalidCap && !showConfirmation && !qMedActivityNotAvailable">
                    <div class="warning-box">
                        <em class="material-icons">warning</em>
                        <div>
                            <div> Your laboratory/organization is not enrolled in this program. You may:</div>
                            <ul>
                                <li>Enter a different laboratory/organization CAP #</li>                               
                                <li>Contact your administrator to purchase for your laboratory/organization</li>
                                <li><a href={{CAP_CONTACT_URL}} target="_blank" rel="noopener noreferrer">Contact the CAP</a></li>
                                <li><a class="cursor-pointer-click" (click)="purchaseForIndvUse()">Purchase this activity for individual use</a></li>
                            </ul>
                        </div>
                    </div>
                    <br />
                </div>
                <div *ngIf=" !hasLabAffiliation && kitsAvailable && !invalidCap && !showConfirmation && !qMedActivityNotAvailable">
                    <div class="warning-box">
                        <em class="material-icons">warning</em>
                        <div>
                            <div> You are currently not affiliated with a laboratory/organization. You may:</div>
                            <ul>
                                <li>Enter laboratory/organization CAP # to create an affiliation</li>                                
                                <li>Contact your administrator to purchase for your laboratory/organization</li>
                                <li><a href={{CAP_CONTACT_URL}} target="_blank" rel="noopener noreferrer">Contact the CAP</a></li>
                                <li><a class="cursor-pointer-click" (click)="purchaseForIndvUse()">Purchase this activity for individual use</a></li>
                            </ul>
                        </div>
                    </div>
                    <br />
                </div>
            </div>
                <div *ngIf="invalidCap">
                    <div class="error-box">
                        <em class="material-icons">warning</em>
                        <div>
                            <p>You have entered an invalid CAP #. Re-enter a CAP #.</p>
                        </div>
                    </div>
                    <br />
                </div>

                <div *ngIf="!affiliationSuccess">
                    <form *ngIf="labSelect" [formGroup]="labSelect" (ngSubmit)="continueToActivity()">
                        <div class="form-group" *ngIf="labsHavingKits.length > 0">
                            <label for="lab"><em style="color:red">* </em><strong>Laboratory/Organization</strong></label>
                           <select class="form-control" formControlName="lab">
                           <option *ngIf="labsHavingKits.length > 1" [ngValue]="SELECT_LAB_TEXT">
                                 {{ SELECT_LAB_TEXT }}
                           </option>

                         <option *ngFor="let l of sortedLabs; let i = index" [ngValue]="l">
                            CAP #: {{ l.capNumber }} {{ l.orgName }}, {{ l.address1 }}, {{ l.city }},
                                {{ l.state }} {{ l.postalCode }}
                          </option>

                          <option [ngValue]="ENTER_CAP_TEXT">{{ ENTER_CAP_TEXT }}</option>

                         <optgroup label="" style="display: none"></optgroup>
                            </select>

                        </div>
                        <div class="form-group" *ngIf="enterCap">
                            <div class="cap-label">
                                <label for="cap"><em style="color:red">* </em><strong>CAP #</strong></label>
                                <em class="material-icons" style="cursor: pointer;"
                                    (click)="toggleTooltip($event, 'ENTER_CAP')">info</em>
                                <div class="cap-tooltip" *ngIf="showEnterCapTooltip">
                                    If you do not know your laboratory/organization CAP #, contact your administrator or
                                    <a href="{{CAP_CONTACT_URL}}" target="_blank" rel="noopener noreferrer">contact the CAP</a>.
                                </div>
                            </div>
                            <input type="text" id="cap"
                                [ngClass]="invalidCap || emptyCap ? 'form-control field-error' : 'form-control'"
                                formControlName="cap">
                            <label class="text" for="cap" [ngClass]="invalidCap || emptyCap ? 'text-error' : ''">Enter 7-digit CAP #</label>
                        </div>
                        <button class="btn_full" type="submit" (click)="continueToActivity()">{{submitFormText}}</button>
                    </form>
                </div>

                <app-lms-confirmation [firstAndLastName]="firstAndLastName" [orgName]="orgFullName" [capNumber]="labInfo.capNumber"
                    [address]="orgFullAddress" [city]="labInfo.city"
                    [state]="labInfo.state" [postalCode]="labInfo.postalCode" *ngIf="showConfirmation"
                    (closeConfirm)="closeConfirmation()" (confirm)="confirmAffiliation()">
                </app-lms-confirmation>
            </div>
        </div>
        </div>
    </main>
</div>
<app-footer></app-footer>
